import { GIS } from 'http-requests';
import { flow, types } from 'mobx-state-tree';
import { RequestStateModel } from 'store/models/general-models';

export const GISModel = types
  .model('GIS', {
    status: types.optional(RequestStateModel, {}),
    isSocketUpdate: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    updateField<K extends keyof typeof self>(
      fieldName: K,
      value: typeof self[K]
    ) {
      self[fieldName] = value;
    },
    syncGISAppeals: flow(function* () {
      try {
        self.status.loadingStates();
        const response = yield GIS.SyncGISAppeals();

        if (response.group_id) {
          localStorage.setItem('gis_sync_group_id', response.group_id);
        } else {
          self.status.finallyStates();

          throw response.message;
        }

        return response;
      } catch (error) {
        self.status.errorStates();
        console.error(error);

        throw typeof error === 'string' ? error : 'Произошла ошибка';
      }
    }),
    checkGISSync: flow(function* () {
      try {
        self.status.loadingStates();
        const response = yield GIS.CheckGISAppealsSync();

        if (response.message === 'import_appeals completed') {
          self.status.finallyStates();
          localStorage.removeItem('gis_sync_group_id');
        }

        return response;
      } catch (error) {
        self.status.errorStates();
        console.error(error);
      }
    }),
  }));
